import axios from 'axios';
import {
  BRANDS_URL,
  DEVICE_MODELS_URL,
  DEVICES_URL,
  FORCE_REGISTER_URL,
  UPLOAD_EXCEL_URL,
  COLORS_URL
} from './urls';
import queryString from 'query-string';

export const useUploadDeviceExcel = () => {
  return async (file, model) => {
    try {
      const formData = new FormData();

      formData.append('records', file);
      formData.append('model', model);
      const res = await axios.post(UPLOAD_EXCEL_URL, formData, {
        headers: {
          authorization: 'bearer ' + localStorage.getItem('token')
        }
      });

      return res.data.file;
    } catch (e) {
      return null;
    }
  };
};


export const useGetDeviceModels = () => {
  return async () => {
    try {
      const res = await axios.get(DEVICE_MODELS_URL, {
        headers: { Authorization: 'bearer ' + localStorage.getItem('token') }
      });

      return res.data.models;
    } catch (e) {
      return {};
    }
  };
};

export const useGetColors = () => {
  return async () => {
    try {
      const res = await axios.get(COLORS_URL, {
        headers: { Authorization: 'bearer ' + localStorage.getItem('token') }
      });
      return res.data.colors;
    } catch (e) {
      return [];
    }
  };
};


export const useCreateBrand = () => {
  return async (name) => {
    try {
      const res = await axios.post(
        BRANDS_URL,
        { name },
        {
          headers: { Authorization: 'bearer ' + localStorage.getItem('token') }
        }
      );

      return res.data.tag;
    } catch (e) {
      return {};
    }
  };
};

export const useCreateModel = () => {
  return async (name, ram, storage, brandTag) => {
    try {
      console.log(name, ram, storage, brandTag);
      const res = await axios.post(
        DEVICE_MODELS_URL,
        { name, ram, storage, brandTag },
        {
          headers: { Authorization: 'bearer ' + localStorage.getItem('token') }
        }
      );

      return res.success;
    } catch (e) {
      return {};
    }
  };
};

export const useCreateColor = () => {
  return async (name, code) => {
    try {
      const res = await axios.post(
        COLORS_URL,
        { name, code },
        {
          headers: { Authorization: 'bearer ' + localStorage.getItem('token') }
        }
      );

      return res.data.tag;
    } catch (e) {
      return {};
    }
  };
};


export const useGetDevicesOfPage = () => {
  return async (page, filters = {}) => {
    try {
      const query = queryString.stringify(filters);
      const res = await axios.get(`${DEVICES_URL}/${page}?${query}`, {
        headers: { Authorization: 'bearer ' + localStorage.getItem('token') }
      });
      const devices = res.data.devices.map((d) => ({
        ...d,
        model: d.model.name,
        nationalId: d.customer?.nationalId,
        customer: d.customer?.name,
        phoneNumber: d.customer?.phoneNumber
      }));
      return { devices, count: res.data.count };
    } catch (e) {
      return {};
    }
  };
};

export const useForceRegistery = () => {
  return async ({ name, dateOfBirth, province, nationalId, imei, phoneNumber }) => {
    try {
      await axios.post(
        FORCE_REGISTER_URL,
        {
          name,
          dateOfBirth,
          province,
          nationalId,
          imei,
          phoneNumber
        },
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token')
          }
        }
      );
      return true;
    } catch (e) {
      return false;
    }
  };
};
